export const displayHidden = (show) => !show && "tw-hidden";

export const taskHasFilters = (hasPrimaryFilters, activeTeamMembers, activeUnassigned) => {
  if (hasPrimaryFilters) return "primary";
  if (activeTeamMembers) return "teamMembers";
  if (activeUnassigned) return "unassigned";
  return null;
};
